import React from 'react'
import Scrollchor from 'react-scrollchor';
// Import styles
import '../../App.css';
import '../../styles/NavBar/navbar.css'

// Import images
import burger from '../../resources/NavBar/burger.svg';
import kronnLogo from '../../resources/HomePageResources/kronn-logo.svg';

export default class NavBar extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            navBarStyle: 'navbar__burger',
            navBarLinksDisplay: 'none'
        };
        this.expandNavBar = this.expandNavBar.bind(this);
        this.hideNavBar = this.hideNavBar.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
    }

    expandNavBar() {
        this.setState({
            navBarStyle: 'navbar__burger navbar__burger-expand-animation',
            navBarLinksDisplay: 'block'
        });
    }

    hideNavBar() {
        this.setState({
            navBarStyle: 'navbar__burger',
            navBarLinksDisplay: 'none'
        });
    }

    onLinkClick() {
        this.setState({
            navBarStyle: 'navbar__burger',
            navBarLinksDisplay: 'none'
        });
    }


    render(){
        return(
            <div className='navbar__container'>

                <div className={this.state.navBarStyle} onMouseEnter={this.expandNavBar} onMouseLeave={this.hideNavBar}>
                    <img src={burger} className='navbar__burger-icon'/>

                    <div className='navbar__nav-links' style={{display: this.state.navBarLinksDisplay}}>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#home-page-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Home</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#fiat-transfer-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Easy transfer</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#exchange-to-fiat-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Exchange to fiat</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#kronn-coin-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Kronn coin</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#get-a-share-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Get a share</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#swift-banking-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Swift banking</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#our-roadmap-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Our roadmap</Scrollchor>
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            <Scrollchor to="#community-anchor" animate={{offset: -100, duration: 600}} style={{marginBottom: '5px'}} className='navbar__nav-text text'>Community</Scrollchor>
                        </div>
                        {/* <a onClick={this.onLinkClick} className='text' href="#home-page-anchor"><div className='navbar__nav-text'>Home</div></a> */}
                        {/* <a onClick={this.onLinkClick} className='text' href="#fiat-transfer-anchor"><div className='navbar__nav-text'>Easy transfer</div></a> */}
                        {/* <a onClick={this.onLinkClick} className='text' href="#exchange-to-fiat-anchor"><div className='navbar__nav-text'>Exchange to fiat</div></a> */}
                        {/* <a onClick={this.onLinkClick} className='text' href="#kronn-bank-anchor"><div style={{cursor: ''}} className='navbar__nav-text'>Kronn bank</div></a> */}
                        {/* <a onClick={this.onLinkClick} className='text' href="#get-a-share-anchor"><div className='navbar__nav-text'>Get a share</div></a> */}
                        {/* <a onClick={this.onLinkClick} className='text' href="#"><div className='navbar__nav-text'>Kronn coin</div></a>
                        <a onClick={this.onLinkClick} className='text' href="#our-roadmap-anchor"><div className='navbar__nav-text'>Our roadmap</div></a>
                        <a onClick={this.onLinkClick} className='text' href="#community-anchor"><div className='navbar__nav-text'>Community</div></a> */}
                    </div>
                </div>

                <div className={this.props.animate}>
                    <img src={kronnLogo} className='navbar__kronn-logo' />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js